"use client"

import React from 'react';

import {AiOutlineMenu} from "react-icons/ai";
import {useAppStore} from "@/store/AppStore";
import styles from "./MenuBtn.module.css";
import {Link} from "@/i18n/routing";
import {useTranslations} from "use-intl";
import {Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import Languages from "@/components/Languages/Languages";
import HikingIcon from '@mui/icons-material/Hiking';
import HomeIcon from '@mui/icons-material/Home';
import PlaceIcon from '@mui/icons-material/Place';
import Login from "@/components/Login/Login";
import {PiHandsPraying} from "react-icons/pi";
import {MdOutlineMobileScreenShare} from "react-icons/md";
import {GiTiedScroll} from "react-icons/gi";
import {GoReport} from "react-icons/go";

const MenuBtn = () => {
  const appStore = useAppStore()
  const menu = useAppStore((state) => state.menu)
  const user = useAppStore((state) => state.user)
  const t = useTranslations("Menu")
  return (
    <div>
      <AiOutlineMenu className={styles.open} size={30} onClick={() => {
        appStore.toggleMenu()
      }}/>
      {menu && <Drawer onClick={() => {
        appStore.toggleMenu()
      }} open={menu}>
        <List>
          <Link href={`/home`}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <HomeIcon/>
                </ListItemIcon>
                <ListItemText primary={t("home")}/>
              </ListItemButton>
            </ListItem>
          </Link>
          <Link href={`/walk`}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <HikingIcon/>
                </ListItemIcon>
                <ListItemText primary={t("walk")}/>
              </ListItemButton>
            </ListItem>
          </Link>
          <Link href={`/pray`}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <PiHandsPraying/>
                </ListItemIcon>
                <ListItemText primary={t("pray")}/>
              </ListItemButton>
            </ListItem>
          </Link>
          <Link href={`/share`}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <MdOutlineMobileScreenShare/>
                </ListItemIcon>
                <ListItemText primary={t("share")}/>
              </ListItemButton>
            </ListItem>
          </Link>
          <Link href={`/places`}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <PlaceIcon/>
                </ListItemIcon>
                <ListItemText primary={t("places")}/>
              </ListItemButton>
            </ListItem>
          </Link>
          <Link href={`/report-poi`}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <GoReport/>
                </ListItemIcon>
                <ListItemText primary={t("report")}/>
              </ListItemButton>
            </ListItem>
          </Link>
          <Link href={`/cartula`}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <GiTiedScroll/>
                </ListItemIcon>
                <ListItemText primary={t("chartula")}/>
              </ListItemButton>
            </ListItem>
          </Link>
        </List>
        <Divider/>
        {user && <List>
          <ListItem sx={{marginBottom: "3rem"}} disablePadding>
            <Link href={`/account`}>
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemIcon>
                    <Login/>
                  </ListItemIcon>
                  <ListItemText primary={t("account")}/>
                </ListItemButton>
              </ListItem>
            </Link>
          </ListItem>
          <ListItem sx={{justifyContent: "center"}} disablePadding>
            <Languages/>
          </ListItem>
        </List>}
        <Divider/>
      </Drawer>}
    </div>)
};

export default MenuBtn;
